const JavascriptRouter = {
    scripts: [],
    register: function (options, callback) {
        const validKeys = ['namespace', 'controller', 'action', 'route'];
        Object.keys(options).forEach((key) => validKeys.includes(key) || delete options[key]);
        JavascriptRouter.scripts.push({options: options, callback: callback});
    },
    start: function (options) {
        const validKeys = ['namespace', 'controller', 'action', 'route'];
        Object.keys(options).forEach((key) => validKeys.includes(key) || delete options[key]);

        JavascriptRouter.scripts.forEach(function (script) {
            if (script.options.route !== undefined) {
                if (script.options.route === options.route || (Array.isArray(script.options.route) && script.options.route.indexOf(options.route) >= 0)) {
                    script.callback();
                }
            } else {
                if (script.options.controller === undefined || script.options.controller === options.controller) {
                    if (script.options.action === undefined) {
                        script.callback();
                    } else if (Array.isArray(script.options.action) && script.options.action.indexOf(options.action) >= 0) {
                        script.callback();
                    } else if (script.options.action === options.action) {
                        script.callback();
                    }
                }
            }
        });
    }
};

window.JavascriptRouter = JavascriptRouter;